import React from 'react';
interface StatusBarProps {
  status: string;
  deadline?: string; // Make deadline optional since we'll calculate it
}
export const StatusBar: React.FC<StatusBarProps> = ({
  status,
  deadline
}) => {
  // Calculate a date two weeks from today
  const calculateDeadline = () => {
    const today = new Date();
    const twoWeeksLater = new Date(today);
    twoWeeksLater.setDate(today.getDate() + 14);
    // Format the date (e.g., "October 15, 2025")
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    const formattedDate = twoWeeksLater.toLocaleDateString('en-US', options);
    // Calculate days remaining
    const daysRemaining = Math.ceil((twoWeeksLater.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    return `${formattedDate} (${daysRemaining} days remaining)`;
  };
  // Use provided deadline or calculate it
  const displayDeadline = deadline || calculateDeadline();
  return <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center bg-white border border-gray-200 rounded-md p-4 mb-6" data-id="element-25">
      <div className="flex items-center mb-2 md:mb-0" data-id="element-26">
        <svg className="w-5 h-5 text-[#fbc02d] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-27">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-28" />
        </svg>
        <span className="font-medium text-[#333333]" data-id="element-29">Proposal Deadline:</span>
        <span className="ml-2 font-bold text-[#333333]" data-id="element-30">{displayDeadline}</span>
      </div>
      <div className="flex items-center" data-id="element-31">
        <span className="font-medium text-[#333333]" data-id="element-32">Your Status:</span>
        <span className="ml-2 px-3 py-1 bg-[#f5f6f8] text-[#333333] rounded-full text-sm font-medium" data-id="element-33">
          {status}
        </span>
      </div>
    </div>;
};